import type {
	ClickEventInput,
	ClickEventPayload,
	ImpressionsEventInput,
	ImpressionsEventPayload,
	ListingEventPayload,
	UseListingEventTrackingReturn
} from './types';

import { buildBaseListingEventPayload } from './buildBasePayload';

const ENDPOINT = '/api/listing-events';

function sendEvent(payload: ListingEventPayload): void {
	try {
		fetch(ENDPOINT, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
			keepalive: true
		}).catch(() => {
			/* fire-and-forget — tracking failures must never reach the user */
		});
	} catch {
		/* fetch may throw synchronously on invalid input — also swallow */
	}
}

export function useListingEventTracking(): UseListingEventTrackingReturn {
	function trackClick(input: ClickEventInput): void {
		if (!import.meta.client) return;

		const payload: ClickEventPayload = {
			...buildBaseListingEventPayload(),
			event_type: 'click',
			property_id: input.property_id,
			clicked_at: input.clicked_at,
			context: input.context
		};
		sendEvent(payload);
	}

	function trackImpressions(input: ImpressionsEventInput): void {
		if (!import.meta.client) return;
		if (input.impressions.length === 0) return;

		const payload: ImpressionsEventPayload = {
			...buildBaseListingEventPayload(),
			event_type: 'impression',
			context: input.context,
			impressions: input.impressions
		};
		sendEvent(payload);
	}

	return { trackClick, trackImpressions };
}
